import { render, staticRenderFns } from "./QiYeManager.vue?vue&type=template&id=c4ec6d80&scoped=true"
import script from "./QiYeManager.vue?vue&type=script&lang=js"
export * from "./QiYeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec6d80",
  null
  
)

export default component.exports